import React from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { FormField, Text, TextArea } from '@legalshield/adonis-ux-framework';

type Props<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  label: string;
  required?: boolean;
  rows?: number;
  maxLength?: number;
};

const TextAreaField = <T extends FieldValues>({
  control,
  name,
  label,
  required,
  rows = 10,
  maxLength = 3000,
}: Props<T>) => (
  <Controller
    control={control}
    name={name}
    render={({ field, fieldState }) => {
      const value = (field.value as string | undefined) ?? '';
      const length = value.length;
      const atLimit = length >= maxLength;
      return (
        <FormField
          id={String(name)}
          label={label}
          required={required}
          status={fieldState.error ? 'invalid' : atLimit ? 'invalid' : undefined}
          validationHint={fieldState.error?.message}
        >
          <TextArea
            placeholder="Please type here..."
            rows={rows}
            value={value}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => field.onChange(e.target.value)}
            onBlur={field.onBlur}
            maxLength={maxLength}
            status={fieldState.error ? 'invalid' : atLimit ? 'invalid' : undefined}
          />
          <Text textSize="description" style={{ color: atLimit ? '#B5021C' : '#545454' }}>
            {`${length}/${maxLength} characters`}
          </Text>
        </FormField>
      );
    }}
  />
);

export default TextAreaField;
